import React from "react";
import * as S from "./MicrositeHeading.styles";
import { IMicrositeHeadingProps } from "./MicrositeHeading.types";
import { useMenu } from "@ubnt/store.core/lib/contexts/MenuContext";
import { Language } from "@ubnt/store.core/lib/types";

export const MicrositeHeading = ({
  title,
  description,
  className,
  isLeftAligned,
  titleWeight,
  isSmallDescription,
  isCentered,
  isMainTitle,
  renderAs,
  descriptionMaxWidth,
  shouldApplyMobileSpacings,
  children,
  spacing,
}: Readonly<React.PropsWithChildren<IMicrositeHeadingProps>>) => {
  const { language } = useMenu();

  return (
    <S.TitleSectionContainer
      $spacing={spacing}
      $isCentered={isCentered}
      $shouldApplyMobileSpacings={shouldApplyMobileSpacings}
      className={className}
    >
      <S.StyledTitle
        as={renderAs}
        $isMainTitle={isMainTitle}
        $titleWeight={titleWeight}
        $isLeftAligned={isLeftAligned}
        $isOtherLanguage={language !== Language.En}
      >
        {title}

        {children}
      </S.StyledTitle>

      {!!description && (
        <S.StyledDescription
          color="tertiary"
          size="header-s"
          $isLeftAligned={isLeftAligned}
          $isSmallDescription={isSmallDescription}
          $descriptionMaxWidth={descriptionMaxWidth}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </S.TitleSectionContainer>
  );
};
